import { useContext } from 'react';
import ResponsiveContext from './ResponsiveContext';

const useResponsiveContext = () => useContext(ResponsiveContext);

export default useResponsiveContext;
